import apiClient from './api';

export interface Warehouse {
  id: string;
  name: string;
  code?: string;
  [key: string]: any;
}

export const warehouseService = {
  async getWarehouses(): Promise<Warehouse[]> {
    const response = await apiClient.get('/admin/inventory/warehouses');
    return response.data;
  },
};
